import React, { useMemo } from 'react';
import { Button, Empty, Table, Tag } from 'antd';
import { PlusOutlined, SettingOutlined } from '@ant-design/icons';
import RowActionsMenu from '../ui/RowActionsMenu';
import { getDataCollectionsTablePagination } from '../collections/collectionUtils';

export default function ToolsTable({
  rows,
  loading,
  onRowClick,
  onAdd,
}) {
  const columns = useMemo(() => [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      render: (name) => <span className="tools-name-cell">{name}</span>,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 80,
      render: (type) => <Tag className="tools-type-tag">{type}</Tag>,
    },
    {
      title: 'Auth',
      dataIndex: 'auth',
      key: 'auth',
      width: 100,
      ellipsis: true,
    },
    {
      title: 'Tools',
      dataIndex: 'toolCount',
      key: 'toolCount',
      width: 72,
      align: 'right',
    },
    {
      title: 'Status',
      dataIndex: 'statusLabel',
      key: 'status',
      width: 110,
      render: (label, row) => {
        const color = row.status === 'error' ? 'error'
          : row.status === 'disabled' ? 'default'
            : row.status === 'pending' ? 'warning' : 'success';
        return <Tag color={color}>{label}</Tag>;
      },
    },
    {
      title: 'Assistants',
      dataIndex: 'linkedCount',
      key: 'linkedCount',
      width: 90,
      align: 'right',
      render: (n, row) => (row.rowType === 'native' ? '—' : (n ?? 0)),
    },
    {
      title: '',
      key: 'actions',
      width: 88,
      fixed: 'right',
      render: (_, row) => {
        if (row.rowType === 'native') return null;
        return (
          <RowActionsMenu
            primaryIcon={<SettingOutlined />}
            primaryLabel="Manage"
            primaryTooltip="Manage connection"
            onPrimaryClick={() => onRowClick?.(row)}
            menuItems={[
              {
                key: 'manage',
                label: 'Manage',
                onClick: () => onRowClick?.(row),
              },
            ]}
          />
        );
      },
    },
  ], [onRowClick]);

  return (
    <Table
      rowKey="key"
      loading={loading}
      dataSource={rows}
      columns={columns}
      pagination={getDataCollectionsTablePagination(10, { totalItemLabel: 'tools' })}
      scroll={{ x: 900 }}
      onRow={(row) => ({
        onClick: () => {
          if (row.rowType === 'native') return;
          onRowClick?.(row);
        },
        style: { cursor: row.rowType === 'native' ? 'default' : 'pointer' },
      })}
      locale={{
        emptyText: (
          <Empty description="No tools configured" image={Empty.PRESENTED_IMAGE_SIMPLE}>
            <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
              Add your first tool
            </Button>
          </Empty>
        ),
      }}
    />
  );
}
